import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { UserService } from '@core/services/user.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { CustomEventService } from '@shared/services/custom-event.service';
import { FileService } from '@shared/services/file.service';
import { beforeUploadFile } from '@shared/utils/file-upload.util';

import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@UntilDestroy()
@Component({
  selector: 'app-add-user-from-CSV-modal',
  templateUrl: './add-user-from-CSV-modal.component.html'
})
export class AddUserFromCSVModalComponent implements OnInit, OnDestroy {

  @Input() mode: string;
  @Input() data: any;
  @Input() loading: boolean;
  availableTypes: 'text/csv';
  file: any;
  fileUploadSuccess = false;
  fileUploadResult: boolean;
  errorMessage: any;

  constructor(private fb: FormBuilder,
              private fileService: FileService,
              private userService: UserService,
              private notificationService: NzNotificationService,
              private nzMessageService: NzMessageService,
              private customEventService: CustomEventService) { }

  beforeUpload = (file: NzUploadFile) => {
    const uploadStatus = beforeUploadFile(file, this.nzMessageService)
    if (uploadStatus) {
      this.file = file
    }
    return uploadStatus;
  };

  ngOnInit(): void {
    this.fileUploadSuccess = false;
    this.errorMessage = undefined;
  }

  submitForm(): void {
    this.fileUploadSuccess = true;

    const formData = new FormData();
    formData.append('file', this.file);

     this.loading = true;

    this.userService.getImportUserList(formData).pipe(untilDestroyed(this))
      .subscribe(_ => {
        this.loading = false;
        this.notificationService.success('User list is imported successfully.', null);
        this.cancelForm();
      },err => {
        if (err.error.message) {
          this.errorMessage = err.error.message;
          this.loading = false;
        }
      })
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  ngOnDestroy(): void {
    // prevent memory leak when component destroyed
  }

}
